<template>
	<div>
		<GmapMap :center="center" ref="map" :zoom="15" :options="mapOptions" map-type-id="terrain" :style="'width: ' + width + 'px; height: ' + height + 'px'" @click="clickMap"> </GmapMap>
		<div class="view_bottom_bt" v-if="viewButton">
			<a href="javascript:;" id="save" type="button" class="search_bt" @click="select()">Select</a>
			&nbsp;<a href="javascript:;" id="save" type="button" class="gray_bt" @click="close()">Close</a>
		</div>
	</div>
</template>

<script>
import { gmapApi } from 'vue2-google-maps';

import { apiInsertGoogleApiLog } from '@/api/index.js';

export default {
	data() {
		return {
			location: {},
			center: { lat: 40.72, lng: -73.96 },
			markers: [],
			map: null,
			mapOptions: {
				mapId: '46fb6c3e4b269cb25ccb5212',
			},
		};
	},
	computed: {
		google: gmapApi,
	},
	props: {
		//initialLat: null,
		//initialLng: null,
		initialLocation: null,
		viewButton: {
			type: Boolean,
			default: true,
		},
		width: {
			type: Number,
			default: 800,
		},
		height: {
			type: Number,
			default: 550,
		},
	},
	watch: {
		initialLocation: {
			handler(newValue) {
				this.location = newValue ? { ...newValue } : {};
				if (this.map) {
					this.setCenter();
				}
			},
			immediate: true, // 초기 로딩 시에도 호출
			deep: true, // 객체 내부 변경 감지
		},
	},
	methods: {
		clickMap(event) {
			//console.log(event);
			if (event.placeId) {
				this.location.place_id = event.placeId;
			}
		},
		clearMarkers() {
			this.markers.forEach(marker => {
				marker.map = null;
			});
			this.markers = [];
		},
		addMarker(position) {
			this.logApi('google.maps.marker.AdvancedMarkerElement');
			const marker = new this.google.maps.marker.AdvancedMarkerElement({
				map: this.map,
				position: { lat: position.lat, lng: position.lng },
			});
			this.markers.push(marker);
		},
		async setCenter() {
			this.clearMarkers();
			var vm = this;
			if (this.location.place_id) {
				//place id가 있는 경우
				try {
					this.logApi('google.maps.places.Place');
					const place = new this.google.maps.places.Place({
						id: this.location.place_id,
					});
					this.logApi('place.fetchFields');
					await place.fetchFields({ fields: ['geometry.location'] });
					if (place.geometry && place.geometry.location) {
						vm.center.lat = place.geometry.location.lat();
						vm.center.lng = place.geometry.location.lng();
						vm.addMarker(vm.center);
					}
				} catch (error) {
					console.error('Error fetching place details:', error);
				}
			} else if (this.location.lat && this.location.lng) {
				//위도 경도가 있는 경우
				this.center.lat = this.location.lat;
				this.center.lng = this.location.lng;
				this.addMarker(this.center);
			} else {
				//그 외는 주소로 찾아본다.
				this.logApi('google.maps.Geocoder');
				const geocoder = new this.google.maps.Geocoder();
				var address = this.location.address_detail + ',' + this.location.address_city + ',' + this.location.address_state + ',' + this.location.address_zipcode + ',' + this.location.country;
				try {
					this.logApi('geocoder.geocode');
					const { results } = await geocoder.geocode({ address: address });
					if (results && results[0]) {
						vm.center.lat = results[0].geometry.location.lat();
						vm.center.lng = results[0].geometry.location.lng();
						vm.addMarker(vm.center);
					}
				} catch (e) {
					console.error('Geocode was not successful for the following reason: ' + e);
				}
			}
		},
		async logApi(api_name) {
			//console.log('google api', api_name, window.location.pathname);

			await apiInsertGoogleApiLog({
				api_name: api_name,
				uri_path: window.location.pathname,
			});
		},
		async select() {
			if (!this.location.place_id) {
				this.$toast.error('Place not selected.');
				return;
			}
			var vm = this;
			try {
				this.logApi('google.maps.places.Place');
				const place = new this.google.maps.places.Place({
					id: this.location.place_id,
				});
				this.logApi('place.fetchFields');
				await place.fetchFields({ fields: ['address_components', 'geometry.location', 'place_id'] });

				if (place.addressComponents) {
					var street_no = '';
					var route = '';
					var city = '';
					var state = '';
					var zipcode = '';
					var country = '';

					for (const component of place.addressComponents) {
						const componentType = component.types[0];
						switch (componentType) {
							case 'street_number':
								street_no = $.trim(component.longText.toUpperCase());
								break;
							case 'route':
								route = $.trim(component.shortText.toUpperCase());
								break;
							case 'locality':
								city = $.trim(component.longText.toUpperCase());
								break;
							case 'political':
								city = $.trim(component.longText.toUpperCase());
								break;
							case 'administrative_area_level_1':
								state = $.trim(component.shortText.toUpperCase());
								break;
							case 'postal_code':
								zipcode = $.trim(component.shortText.toUpperCase());
								break;
							case 'country':
								country = $.trim(component.shortText.toUpperCase());
								break;
						}
					}

					if (place.geometry && place.geometry.location) {
						vm.location.lat = place.geometry.location.lat();
						vm.location.lng = place.geometry.location.lng();
					}
					vm.location.place_id = place.id;
					vm.location.address_detail = street_no + ' ' + route;
					vm.location.address_city = city;
					vm.location.address_state = state;
					vm.location.address_zipcode = zipcode;
					if (country == 'US') country = 'USA';
					vm.location.country = country;

					vm.$emit('updateLocation', vm.location);
					vm.close();
				}
			} catch (error) {
				console.error('Error fetching place details:', error);
				this.$toast.error('Error fetching place details.');
			}
		},
		close() {
			//console.log('cancel');
			this.$emit('close');
		},
		// geolocate: function() {
		// 	navigator.geolocation.getCurrentPosition(position => {
		// 		this.center = {
		// 			lat: position.coords.latitude,
		// 			lng: position.coords.longitude,
		// 		};
		// 	});
		// },
	},
	created() {
		this.location = this.initialLocation ? this.initialLocation : null;
	},
	mounted() {
		this.$refs.map.$mapPromise.then(map => {
			this.map = map;
			// this.setCenter();
		});
	},
};
</script>

<style></style>
